// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 7144 ? "fa3de7d5" : chunkId) + "." + {"1352":"80fcfcfe39afbc66","2923":"4d34a4249d30e224","5057":"5377e036dc9bf344","7144":"b26aa8a7ea009f65","9506":"7f7f751f6c99f396"}[chunkId] + ".js";
};